<template>
  <div>
    <v-menu
      v-model="showMenu"
      :close-on-content-click="false"
      :disabled="$attrs.disabled ? $attrs.disabled : false"
      :nudge-right="40"
      full-width
      lazy
      min-width="290px"
      offset-y
      transition="scale-transition"
    >
      <template v-slot:activator="{ on }">
        <v-text-field
          ref="dateField"
          v-model="textDate"
          :disabled="$attrs.disabled ? $attrs.disabled : false"
          :label="label"
          :value="computedDateFormatted"
          clearable
          prepend-icon="event"
          @change="checkValidDateAndEmit"
          v-on="on"
          @click:clear="clearDate"
        />
      </template>
      <v-date-picker
        v-model="date"
        :max="max"
        :min="min"
        :title-date-format="formatDate"
        first-day-of-week="1"
        locale="de"
        @input="dateChanged"
      />
    </v-menu>
  </div>
</template>

<script>
import moment from "moment";

function detectLocaleDateFormat() {
  // Browsers always report UI language locale via Intl, never the OS regional format.
  // For this Swiss application we default to DD.MM.YYYY and use navigator.languages
  // to switch to DD/MM/YYYY for French and Italian regions.
  const lang = (navigator.languages && navigator.languages[0]) || navigator.language || "";
  if (/^(fr|it)/i.test(lang)) {
    return "DD/MM/YYYY";
  }
  return "DD.MM.YYYY";
}

// Try all common European + US date formats in order of preference
const FALLBACK_FORMATS = [
  "DD.MM.YYYY",
  "DD/MM/YYYY",
  "MM/DD/YYYY",
  "YYYY-MM-DD",
];

export default {
  name: "UDatePicker",
  props: {
    label: {
      type: String,
      required: true,
    },
    value: {
      type: String,
      required: false,
      default: "",
    },
    format: {
      type: String,
      default: null,
    },
    max: {
      type: String,
      default: undefined,
    },
    min: {
      type: String,
      default: undefined,
    },
  },
  data() {
    return {
      showMenu: false,
      date: null,
      textDate: null,
      localeDateFormat: this.format || detectLocaleDateFormat(),
    };
  },
  computed: {
    computedDateFormatted() {
      return this.formatDate();
    },
  },
  watch: {
    value() {
      this.date = this.value ? this.value : "";
      this.textDate = this.formatDate();
    },
  },
  created: function () {
    this.date = this.value ? this.value : "";
    this.textDate = this.formatDate();
  },
  methods: {
    checkValidDateAndEmit() {
      if (!this.textDate) {
        this.date = null;
        this.dateChanged();
        return;
      }

      //First trim whitespace from the input
      const trimmedDate = this.textDate.trim();

      // First try the detected locale format strictly, then fall back to all known formats
      const formatsToTry = [
        this.localeDateFormat,
        ...FALLBACK_FORMATS.filter((f) => f !== this.localeDateFormat),
      ];
      const parsed = moment(trimmedDate, formatsToTry, true);
      if (parsed.isValid()) {
        this.date = parsed.format("YYYY-MM-DD");
        this.dateChanged();
      } else {
        console.error("invalid Date input: " + trimmedDate);
      }
    },
    dateChanged() {
      this.showMenu = false;
      this.textDate = this.formatDate(this.date);
      this.$emit("input", this.date);
      this.$emit("change", this.date);
    },
    formatDate() {
      return this.date ? moment(this.date).format(this.localeDateFormat) : "";
    },
    clearDate() {
      this.date = null;
      this.$emit("input", this.date);
      this.$emit("change", this.date);
    },
  },
};
</script>
